import type { NormalizeOAS, OASOutput } from 'fets';
import type openapi from '../../../rest-api/openapi';
import { ApiClient } from '../../../rest-api/fetsClient';

type AllowedDomainResult = OASOutput<
  NormalizeOAS<typeof openapi>,
  '/api/course-exports/{courseExportGuid}/allowed-domains',
  'post'
>;

export const createAllowedDomainsApi = (apiClient: ApiClient) => {
  const addAllowedDomain = async (courseExportGuid: string, domain: string): Promise<AllowedDomainResult> => {
    const response = await apiClient['/api/course-exports/{courseExportGuid}/allowed-domains'].post({
      params: { courseExportGuid },
      json: { domain },
    });
    const data = await response.json();
    return {
      guid: data.guid,
      domain: data.domain,
    };
  };

  const updateAllowedDomain = async (allowedDomainGuid: string, domain: string): Promise<AllowedDomainResult> => {
    const response = await apiClient['/api/course-exports/allowed-domains/{allowedDomainGuid}'].put({
      params: { allowedDomainGuid },
      json: { domain },
    });
    const data = await response.json();
    return {
      guid: data.guid,
      domain: data.domain,
    };
  };

  const deleteAllowedDomain = async (allowedDomainGuid: string): Promise<void> => {
    await apiClient['/api/course-exports/allowed-domains/{allowedDomainGuid}'].delete({
      params: { allowedDomainGuid },
    });
  };

  return {
    addAllowedDomain,
    updateAllowedDomain,
    deleteAllowedDomain,
  };
};
